import React, { FC, useState } from 'react';
import { isPdfPath, resolveUploadFileUrl } from 'helpers/resolveUploadFileUrl';
import imageService from 'services/api/image.service';

interface ViewPdfLinkProps {
    path: string | null | undefined;
    /** EPCIS document URN for authenticated backend PDF download (local dev). */
    documentId?: string | null;
    className?: string;
}

const ViewPdfLink: FC<ViewPdfLinkProps> = ({ path, documentId, className }) => {
    const [loading, setLoading] = useState(false);

    const linkClass =
        className ||
        'row-detail-panel__pdf-link text-yellow-600 hover:text-yellow-800 hover:underline font-semibold';

    const openViaApi = async () => {
        if (!documentId) return;
        setLoading(true);
        try {
            const response = await imageService.downloadEpcis({ urn: documentId });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank', 'noopener,noreferrer');
            window.setTimeout(() => window.URL.revokeObjectURL(url), 60_000);
        } catch (err: unknown) {
            const message =
                (err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
                (err as Error)?.message ||
                'Could not load PDF';
            alert(message);
        } finally {
            setLoading(false);
        }
    };

    if (documentId && isPdfPath(path)) {
        return (
            <button
                type="button"
                disabled={loading}
                onClick={() => void openViaApi()}
                className={`${linkClass} disabled:opacity-50`}
            >
                {loading ? 'Loading PDF…' : '👁️ View PDF'}
            </button>
        );
    }

    const href = resolveUploadFileUrl(path);
    if (!href) {
        return null;
    }

    return (
        <a href={href} target="_blank" rel="noreferrer" className={linkClass}>
            👁️ View PDF
        </a>
    );
};

export default ViewPdfLink;
